export{HttpCustomerService} from './httpcustomer.service';
export{MapclientServiceService} from './mapclient.service.service';
export{MessageclientService} from './messageclient.service';
export{NativeService} from './native.service';
export{SignalrclientService} from './signalrclient.service';
export{SqliteServicesService} from './sqlite-services.service';
export{StaticService} from './static.service';
export{UploadHotService} from './upload-hot.service';
export{WxjssdkService} from './wxjssdk.service';